<template>
    <div class="border-t border-gray-400 pb-5">
        <h2 class="text-gray-400 text-sm p-5 pb-3 md:pb-5">{{ $t('search.recent') }}</h2>
        <div class="flex gap-3 items-center pl-5 overflow-hidden overflow-x-auto scrollbar-hide">
            <AtomLabel
                v-for="(recentSearch, index) in recentSearches"
                :key="index"
                :text="recentSearch"
                class="cursor-pointer"
            />
            <p
                v-if="!recentSearches || recentSearches.length === 0"
                class="text-gray-400 text-sm"
            >
                {{ $t('search.recent_empty') }}
            </p>
        </div>
    </div>
</template>
<script>

import AtomLabel from "../atoms/AtomLabel.vue";

export default {
    name: 'MoleculePreviewRecent',
    components: {AtomLabel},
    props: {
        recentSearches: null
    }
}
</script>
